/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import template from './views/publishedReport.html';
import controller from './controllers/publishedReportController';
var module = angular.module('PublishedReportModule', [
    //import modules
])
.controller('publishedReports', controller);


// module.constant('pulishedReportCardConstants', {
//     NO_FEESCHOOLS: ['2FwuqhgeoKt6SQiCG'],
// })
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('publishedReports', {
//             parent: 'app',
//             url: '/published-reports/:student_id/:fee_status',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'publishedReportsListCtrl'
//                 }
//             }
//         })

// });


// WEBPACK FOOTER //
// ./src/app/report_cards/published_reports/publishedReportModule.js